import { render, staticRenderFns } from "./CreatePhaseStatusVerticalStep1.vue?vue&type=template&id=327b86fc&"
import script from "./CreatePhaseStatusVerticalStep1.vue?vue&type=script&lang=ts&"
export * from "./CreatePhaseStatusVerticalStep1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports